// Completing the psychotherapy case: the answers go to the server, which files
// the signed documents and tells Booking (vertraege.submitted). Called from the
// payment step and, for returning patients with a mandate (no payment step),
// from the final screen. Idempotent on both sides.
import { vertraegeService, getApiErrorCode } from '../services/api'
import { useOnboardingStore } from '../store/onboardingStore'
import { buildPtAnswers } from './ptAnswers'
import { logger } from '../utils/logger'

export type PtCompleteResult = 'ok' | 'not_signed' | 'incomplete' | 'error'

export async function completePtCase(paymentMethod: 'sepa' | 'rechnung'): Promise<PtCompleteResult> {
  const st = useOnboardingStore.getState()
  if (st.cohort === 'standard' || st.ptCompleted) return 'ok'
  try {
    await vertraegeService.complete(st.insuranceData.insuranceType, buildPtAnswers(st, paymentMethod))
    useOnboardingStore.getState().setPtCompleted(true)
    return 'ok'
  } catch (err) {
    const code = getApiErrorCode(err)
    logger.error('[PT] completion failed:', code, err)
    if (code === 'not_signed') return 'not_signed'
    if (code === 'answers_incomplete' || code === 'answers_invalid') return 'incomplete'
    return 'error'
  }
}
